import { render, staticRenderFns } from "./PictureUploadSection.vue?vue&type=template&id=7cc0a673&scoped=true&"
import script from "./PictureUploadSection.vue?vue&type=script&lang=js&"
export * from "./PictureUploadSection.vue?vue&type=script&lang=js&"
import style0 from "./PictureUploadSection.vue?vue&type=style&index=0&id=7cc0a673&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc0a673",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cc0a673')) {
      api.createRecord('7cc0a673', component.options)
    } else {
      api.reload('7cc0a673', component.options)
    }
    module.hot.accept("./PictureUploadSection.vue?vue&type=template&id=7cc0a673&scoped=true&", function () {
      api.rerender('7cc0a673', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/space/components/PictureUploadSection.vue"
export default component.exports